module.exports = __webpack_public_path__ + "static/media/reports_cancellation.480fea8b.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/reports_cancellation.md
// module id = 1109
// module chunks = 0